"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTemplateUtils = void 0;
const common_1 = require("@finley-technologies/common");
const dbNodes = __importStar(require("../dbNodes/dbNodes"));
const createTemplateUtils = (params) => {
    const prefix = `[artifactDocumentId:${params.artifactDocumentId}]`;
    // only BE code should use this utility
    (0, common_1.finleyAssert)(common_1.utils.EnvUtils.isBackend(), `${prefix}: createTemplateUtils should only be used in the backend`);
    return {
        /**
         * Clones the graph from a template.
         * This does not anonymize the graph,
         * and should only be used with trusted templates.
         */
        cloneTemplateGraph: ({ newArtifactDocumentId, cloneMap, }) => {
            const oldIdToNewIdMap = new Map(); // oldId => newId
            const newArtifacts = params.artifacts.map((artifact) => {
                let newArtifact;
                switch (artifact.type) {
                    case dbNodes.assignedLoanTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.assignedLoanTape.isNode(artifact), `${prefix}: expected assignedLoanTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.assignedLoanTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.assignedRepaymentTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.assignedRepaymentTape.isNode(artifact), `${prefix}: expected assignedRepaymentTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.assignedRepaymentTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.borrowingBaseReport.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.borrowingBaseReport.isNode(artifact), `${prefix}: expected borrowingBaseReport node, got: ${artifact.type}`);
                        newArtifact = dbNodes.borrowingBaseReport.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.cashBalancesFeedContext.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.cashBalancesFeedContext.isNode(artifact), `${prefix}: expected cashBalancesFeedContext node, got: ${artifact.type}`);
                        newArtifact = dbNodes.cashBalancesFeedContext.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.cashResponseTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.cashResponseTape.isNode(artifact), `${prefix}: expected cashResponseTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.cashResponseTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.configTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.configTape.isNode(artifact), `${prefix}: expected configTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.configTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.dataLakeTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.dataLakeTape.isNode(artifact), `${prefix}: expected dataLakeTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.dataLakeTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.directInsertBorrowingBaseReport.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.directInsertBorrowingBaseReport.isNode(artifact), `${prefix}: expected directInsertBorrowingBaseReport node, got: ${artifact.type}`);
                        newArtifact = dbNodes.directInsertBorrowingBaseReport.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.directInsertPortfolioCovenant.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.directInsertPortfolioCovenant.isNode(artifact), `${prefix}: expected directInsertPortfolioCovenant node, got: ${artifact.type}`);
                        newArtifact = dbNodes.directInsertPortfolioCovenant.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.directInsertPortfolioCovenants.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.directInsertPortfolioCovenants.isNode(artifact), `${prefix}: expected directInsertPortfolioCovenants node, got: ${artifact.type}`);
                        newArtifact = dbNodes.directInsertPortfolioCovenants.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.directInsertFinancialCovenants.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.directInsertFinancialCovenants.isNode(artifact), `${prefix}: expected directInsertFinancialCovenants node, got: ${artifact.type}`);
                        newArtifact = dbNodes.directInsertFinancialCovenants.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.forwardedTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.forwardedTape.isNode(artifact), `${prefix}: expected forwardedTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.forwardedTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.fundingApprovalReport.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.fundingApprovalReport.isNode(artifact), `${prefix}: expected fundingApprovalReport node, got: ${artifact.type}`);
                        newArtifact = dbNodes.fundingApprovalReport.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.fundingRequest.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.fundingRequest.isNode(artifact), `${prefix}: expected fundingRequest node, got: ${artifact.type}`);
                        newArtifact = dbNodes.fundingRequest.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.fundingVerificationReport.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.fundingVerificationReport.isNode(artifact), `${prefix}: expected fundingVerificationReport node, got: ${artifact.type}`);
                        newArtifact = dbNodes.fundingVerificationReport.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.generatedCashBalanceFeed.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.generatedCashBalanceFeed.isNode(artifact), `${prefix}: expected generatedCashBalanceFeed node, got: ${artifact.type}`);
                        newArtifact = dbNodes.generatedCashBalanceFeed.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.generatedCovenantLoanTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.generatedCovenantLoanTape.isNode(artifact), `${prefix}: expected generatedCovenantLoanTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.generatedCovenantLoanTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.generatedFinancialData.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.generatedFinancialData.isNode(artifact), `${prefix}: expected generatedFinancialData node, got: ${artifact.type}`);
                        newArtifact = dbNodes.generatedFinancialData.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.generatedLoanTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.generatedLoanTape.isNode(artifact), `${prefix}: expected generatedLoanTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.generatedLoanTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.generatedRepaymentTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.generatedRepaymentTape.isNode(artifact), `${prefix}: expected generatedRepaymentTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.generatedRepaymentTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.generatedSupplementalTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.generatedSupplementalTape.isNode(artifact), `${prefix}: expected generatedSupplementalTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.generatedSupplementalTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.intermediateTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.intermediateTape.isNode(artifact), `${prefix}: expected intermediateTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.intermediateTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.internalRepaymentTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.internalRepaymentTape.isNode(artifact), `${prefix}: expected internalRepaymentTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.internalRepaymentTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.limitedPartnersTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.limitedPartnersTape.isNode(artifact), `${prefix}: expected limitedPartnersTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.limitedPartnersTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.manualBankAccountReport.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.manualBankAccountReport.isNode(artifact), `${prefix}: expected manualBankAccountReport node, got: ${artifact.type}`);
                        newArtifact = dbNodes.manualBankAccountReport.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.masterLoanTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.masterLoanTape.isNode(artifact), `${prefix}: expected masterLoanTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.masterLoanTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.orgProvidedInput.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.orgProvidedInput.isNode(artifact), `${prefix}: expected orgProvidedInput node, got: ${artifact.type}`);
                        newArtifact = dbNodes.orgProvidedInput.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.orgProvidedInputs.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.orgProvidedInputs.isNode(artifact), `${prefix}: expected orgProvidedInputs node, got: ${artifact.type}`);
                        newArtifact = dbNodes.orgProvidedInputs.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.rawCashBalanceFeed.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.rawCashBalanceFeed.isNode(artifact), `${prefix}: expected rawCashBalanceFeed node, got: ${artifact.type}`);
                        newArtifact = dbNodes.rawCashBalanceFeed.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.rawLoanTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.rawLoanTape.isNode(artifact), `${prefix}: expected rawLoanTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.rawLoanTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.rawReceivableDocumentation.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.rawReceivableDocumentation.isNode(artifact), `${prefix}: expected rawReceivableDocumentation node, got: ${artifact.type}`);
                        newArtifact = dbNodes.rawReceivableDocumentation.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.rawRepaymentTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.rawRepaymentTape.isNode(artifact), `${prefix}: expected rawRepaymentTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.rawRepaymentTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.rawSupplementalTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.rawSupplementalTape.isNode(artifact), `${prefix}: expected rawSupplementalTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.rawSupplementalTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.rawZipTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.rawZipTape.isNode(artifact), `${prefix}: expected rawZipTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.rawZipTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.receivableDocumentationVerificationReport.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.receivableDocumentationVerificationReport.isNode(artifact), `${prefix}: expected receivableDocumentationVerificationReport node, got: ${artifact.type}`);
                        newArtifact = dbNodes.receivableDocumentationVerificationReport.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.receivableInvoice.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.receivableInvoice.isNode(artifact), `${prefix}: expected receivableInvoice node, got: ${artifact.type}`);
                        newArtifact = dbNodes.receivableInvoice.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.receivableResponseTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.receivableResponseTape.isNode(artifact), `${prefix}: expected receivableResponseTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.receivableResponseTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.receivableResponseTapePreview.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.receivableResponseTapePreview.isNode(artifact), `${prefix}: expected receivableResponseTapePreview node, got: ${artifact.type}`);
                        newArtifact = dbNodes.receivableResponseTapePreview.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.userInputNeeded.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.userInputNeeded.isNode(artifact), `${prefix}: expected userInputNeeded node, got: ${artifact.type}`);
                        newArtifact = dbNodes.userInputNeeded.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.valleyBankIngest.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.valleyBankIngest.isNode(artifact), `${prefix}: expected valleyBankIngest node, got: ${artifact.type}`);
                        newArtifact = dbNodes.valleyBankIngest.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.valleyBankSlsIngest.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.valleyBankSlsIngest.isNode(artifact), `${prefix}: expected valleyBankSlsIngest node, got: ${artifact.type}`);
                        newArtifact = dbNodes.valleyBankSlsIngest.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.valleyBankSlsCommitment.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.valleyBankSlsCommitment.isNode(artifact), `${prefix}: expected valleyBankSlsCommitment node, got: ${artifact.type}`);
                        newArtifact = dbNodes.valleyBankSlsCommitment.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.waitForDataLakeTable.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.waitForDataLakeTable.isNode(artifact), `${prefix}: expected waitForDataLakeTable node, got: ${artifact.type}`);
                        newArtifact = dbNodes.waitForDataLakeTable.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.uploadToDatalake.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.uploadToDatalake.isNode(artifact), `${prefix}: expected uploadToDatalake node, got: ${artifact.type}`);
                        newArtifact = dbNodes.uploadToDatalake.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.finStatement.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.finStatement.isNode(artifact), `${prefix}: expected finStatement node, got: ${artifact.type}`);
                        newArtifact = dbNodes.finStatement.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.reconciledBusTape.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.reconciledBusTape.isNode(artifact), `${prefix}: expected reconciledBusTape node, got: ${artifact.type}`);
                        newArtifact = dbNodes.reconciledBusTape.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    case dbNodes.busCertificate.artifactType:
                        (0, common_1.finleyAssert)(dbNodes.busCertificate.isNode(artifact), `${prefix}: expected busCertificate node, got: ${artifact.type}`);
                        newArtifact = dbNodes.busCertificate.cloneFromTemplateArtifact({
                            artifactToClone: artifact,
                            newArtifactDocumentId,
                            cloneMap,
                        });
                        break;
                    default:
                        return (0, common_1.finleyAssertUnreachable)(artifact.type);
                }
                (0, common_1.finleyAssert)(artifact.id !== newArtifact.id, `${prefix}: artifact id must change during clone: ${artifact.id} => ${newArtifact.id}`);
                oldIdToNewIdMap.set(artifact.id, newArtifact.id);
                return newArtifact;
            });
            // now we need to update dependencies.
            const newDependencies = params.dependencies.map((dependency) => {
                const outputArtifactId = oldIdToNewIdMap.get(dependency.outputArtifactId);
                const inputArtifactId = oldIdToNewIdMap.get(dependency.inputArtifactId);
                (0, common_1.finleyAssert)(outputArtifactId && inputArtifactId, `${prefix}: dependency not found in oldIdToNewIdMap: ${JSON.stringify(dependency)}`);
                return {
                    outputArtifactId,
                    inputArtifactId,
                };
            });
            return {
                artifacts: newArtifacts,
                dependencies: newDependencies,
            };
        },
    };
};
exports.createTemplateUtils = createTemplateUtils;
//# sourceMappingURL=templateClone.js.map